// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_btn__WfOwo {
    font-size: 14px;
    padding: 4px 10px;
    border-radius: 10px;
    border: 1px solid;
    color: #fff;
    font-family: 'Gilroy-Medium';
}
.button_btnDarkBlue__9vw6H {
    background: #2384EF;
    border-color: #2384EF;
}
.button_btnBlue__OXVvf {
    background-color: #6ABFE9;
    border-color: #6ABFE9;
}`, "",{"version":3,"sources":["webpack://./src/components/button.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":[".btn {\n    font-size: 14px;\n    padding: 4px 10px;\n    border-radius: 10px;\n    border: 1px solid;\n    color: #fff;\n    font-family: 'Gilroy-Medium';\n}\n.btnDarkBlue {\n    background: #2384EF;\n    border-color: #2384EF;\n}\n.btnBlue {\n    background-color: #6ABFE9;\n    border-color: #6ABFE9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `button_btn__WfOwo`,
	"btnDarkBlue": `button_btnDarkBlue__9vw6H`,
	"btnBlue": `button_btnBlue__OXVvf`
};
export default ___CSS_LOADER_EXPORT___;
